import React from 'react';
import styles from './SmartRenderer.module.scss';
import MarkdownRenderer from '../../utils/MarkdownRenderer/MarkdownRenderer';

const isLikelyHTML = (s='') => /^\s*</.test(String(s).trim());

export default function SmartRenderer({ content }) {
  if (!content) return null;
  if (isLikelyHTML(content)) {
    return <div dangerouslySetInnerHTML={{ __html: content }} />;
  }
  return <MarkdownRenderer content={content} />;
}
